
import { observable, runInAction, action, toJS } from 'mobx';
import Echarts from "echarts";

const color = ['#4c9bf2', '#4AC18E', '#D9534F', '#67A8E4'];
const dataName = {
    FB: "F&B Revenue 餐饮收入",
    Other_Cost: "Other Expense and Cost 其他费用及成本",
    Payroll_Expense: "Total Payroll Expense 人力资源总费用",
    Utility: "Utility Cost 能源成本",
    food: "F&B Total Cost 食品及饮品成本",
    occupied: "出租可房间夜数",
    other_revenue: "Other Revenue 其他部门收入 ",
    profit: "总利润",
    revenue: "总收入",
    rooms: "Rooms Revenue 客房收入",
};
Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class store {
    @observable data = [];
    @observable loading = false;
    @observable profit = [];
    @observable revenue = [];
    @observable occ = [];
    @observable arr = [];
    @observable hotel_id = 1;

    @action
    getData = async () => {
        this.loading = true;

        try {
            const res = await fetch('/bi_headquarters', { credentials: 'include' });
            const json = await res.json();
            const data = json.data || {};

            const revenue = data.sort((a, b) => b.revenue - a.revenue).map((item, i) => ({ ...item, index: i + 1 }));
            const profit = data.sort((a, b) => b.profit - a.profit).map((item, i) => ({ ...item, index: i + 1 }));
            const occ = data.sort((a, b) => b.occ - a.occ).map((item, i) => ({ ...item, index: i + 1 }));
            const arr = data.sort((a, b) => b.arr - a.arr).map((item, i) => ({ ...item, index: i + 1 }));
            const dataRevenue = ['rooms', 'FB', 'other_revenue'];
            const dataProfit = ['food', 'Payroll_Expense', 'Utility', 'Other_Cost'];

            this.setProportion({
                id: "Proportion",
                dataRevenue: dataRevenue.map(name => {
                    const d = data.find((x, i) => x.id == 1) || {};
                    return {
                        name: dataName[name],
                        value: Number(d[name]).toFixed(2)
                    }
                }),
                dataProfit: dataProfit.map(name => {
                    const d = data.find((x, i) => x.id == 1) || {};
                    return {
                        name: dataName[name],
                        value: Number(d[name]).toFixed(2)
                    }
                }),
                dataRooms: data.sort((a, b) => b.occupied - a.occupied).filter((x, i) => i <= 9).map(x => {
                    return { name: x.name, value: Number(x.occupied).toFixed(0) }
                })
            });

            runInAction(() => {
                this.loading = false;
                this.revenue = revenue;
                this.profit = profit;
                this.occ = occ;
                this.arr = arr;
                this.data = data;
            });
        } catch (error) {
            console.error(error);
            runInAction(() => {
                this.loading = false;
            });
        }
    }

    setKarte = (data, isOnResize) => {
        const { id, dataX, dataY, } = data;
        var myChart = Echarts.init(document.getElementById(id));
        myChart.resize();
        if (isOnResize) {
            return
        }
        const option = {
            backgroundColor: '#fff',
            legend: {

                top: '30',
                data: dataY.map(x => (x.name))
            },
            color,
            grid: {
                bottom: '35%',
                // right: '18%',
                // left: '18%',
                // top: '15%'
            },
            xAxis: {
                splitLine: {
                    lineStyle: {
                        show: true,
                        type: 'dashed'
                    }
                },
                "axisLabel": {
                    "interval": 5,
                    rotate: 40,
                    textStyle: {
                        fontSize: 12,
                        color: '#000'
                    },
                },
                data: dataX,
            },
            yAxis: {
                name: '张',
                splitLine: {
                    lineStyle: {
                        type: 'dashed'
                    }
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b}<br/>{a} : {c}'

            },
            series: dataY.map(item => ({
                name: item.name,
                // symbolSize: function (data) {
                //     return Math.sqrt(data) * 2;
                // },
                type: 'scatter',
                data: item.data,
                markPoint: {
                    data: [
                        { type: 'max', name: '最大值' },
                        { type: 'min', name: '最小值' }
                    ]
                },
                markLine: {
                    data: [
                        { type: 'average', name: '平均值' }
                    ]
                }
            }))
        };

        myChart.setOption(option);
    }

    setProportion = (data, isOnResize) => {
        const { id, dataRevenue, dataProfit, dataRooms } = data;

        const myChart = Echarts.init(document.getElementById(id));
        myChart.resize();
        if (isOnResize) {
            return
        }
        const option = {
            title: [
                { text: "收入占比", x: '1%', y: '1%', textStyle: { color: "#333", fontSize: "16" } },
                { text: "成本占比", x: '55%', y: '1%', textStyle: { color: "#333", fontSize: "16" } },
            ],
            grid: [
                { x: '60%', y: '7%', width: '45%', height: '90%' },
            ],
            tooltip: {
                formatter: '{b} ({c})'
            },
            series: [
                {
                    name: '收入占比',
                    type: 'pie',
                    radius: '70%',
                    center: ['20%', '60%'],
                    data: dataRevenue,
                    color,

                    itemStyle: { normal: { label: { show: true, formatter: '{b} \n ({d}%)', textStyle: { color: '#333' } } }, },
                },
                {
                    name: '成本占比',
                    type: 'pie',
                    radius: '70%',
                    center: ['75%', '60%'],

                    color,
                    data: dataProfit,
                    itemStyle: { normal: { label: { show: true, formatter: '{b} \n ({d}%)', textStyle: { color: '#333' } } }, },
                },

            ]
        };

        myChart.setOption(option);
    }

    onResize = () => {
        this.setProportion({ id: "Proportion" }, true);
    }


    @action onChangeHotelId = (id) => {
        this.hotel_id = id;
        const data = toJS(this.data);
        const dataRevenue = ['rooms', 'FB', 'other_revenue'];
        const dataProfit = ['food', 'Payroll_Expense', 'Utility', 'Other_Cost'];
        this.setProportion({
            id: "Proportion",
            dataRevenue: dataRevenue.map(name => {
                const d = data.find((x, i) => x.id == id) || {};
                return {
                    name: dataName[name],
                    value: Number(d[name]).toFixed(2)
                }
            }),
            dataProfit: dataProfit.map(name => {
                const d = data.find((x, i) => x.id == id) || {};
                return {
                    name: dataName[name],
                    value: Number(d[name]).toFixed(2)
                }
            }),
            dataRooms: data.sort((a, b) => b.occupied - a.occupied).filter((x, i) => i <= 9).map(x => {
                return { name: x.name, value: Number(x.occupied).toFixed(0) }
            })
        });
    }
};

const allHotel = new store();

export default allHotel;



// WEBPACK FOOTER //
// ./src/store/BI/allHotel.js